import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { serviceMeta } from '../data/services';
import { useLanguage } from '../contexts/LanguageContext';
import { SectionHeading } from './SectionHeading';
import { SparkleIcon } from './icons/GoldIcons';
const ease = [0.23, 1, 0.32, 1] as const;
export function Services() {
  const {
    t
  } = useLanguage();
  const [activeId, setActiveId] = useState(serviceMeta[0].id);
  const activeIndex = Math.max(serviceMeta.findIndex(c => c.id === activeId), 0);
  const active = {
    ...serviceMeta[activeIndex],
    ...t.services.categories[activeIndex]
  };
  return <section id="servicios" className="w-full bg-ink-800 pb-24 pt-2 sm:pb-32 sm:pt-3" data-id="element-335" data-mp="u6l7kpmllvl6">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-336" data-mp="q5rk1xd2iist">
        <SectionHeading eyebrow={t.services.eyebrow} title={t.services.title} intro={t.services.intro} data-id="element-337" data-mp="l53qp51d9pvf" />

        <div role="tablist" aria-label={t.a11y.serviceTabs} className="mt-14 grid grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-6" data-id="element-338" data-mp="g5quhtolv6g6">
          {serviceMeta.map((meta, index) => {
          const category = t.services.categories[index];
          const isActive = meta.id === active.id;
          return <button key={meta.id} role="tab" type="button" id={`tab-${meta.id}`} aria-selected={isActive} aria-controls="panel-servicios" onClick={() => setActiveId(meta.id)} className={`group relative overflow-hidden rounded-2xl border text-left transition-colors duration-200 ${isActive ? 'border-gold-soft' : 'border-gold-deep/30 hover:border-gold-deep/70'}`} data-id="element-339" data-mp="2xc1ib3jb2kwx" data-mpi={index}>
                <img src={meta.image} alt={category.imageAlt} loading="lazy" className={`aspect-[4/5] w-full object-cover transition-[transform,opacity,filter] duration-300 ease-out group-hover:scale-[1.04] ${isActive ? 'opacity-100 saturate-100' : 'opacity-55 saturate-[0.55] group-hover:opacity-85'}`} data-id="element-340" data-mp="3u192a74a0lyq" />
                <span aria-hidden="true" className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_top,rgba(7,6,5,0.94),rgba(7,6,5,0.05)_58%)]" data-id="element-341" data-mp="24p724itiu7p9" />
                <span aria-hidden="true" className={`pointer-events-none absolute -inset-y-10 -left-1/3 w-1/3 rotate-12 bg-[linear-gradient(90deg,transparent,rgba(255,244,194,0.22),transparent)] transition-transform duration-300 ease-out ${isActive ? 'translate-x-[420%]' : '-translate-x-full group-hover:translate-x-[420%]'}`} data-id="element-342" data-mp="1pj19a499e2uq" />

                <span className="absolute inset-x-0 bottom-0 block p-4 sm:p-5" data-id="element-343" data-mp="1bsfoub45pkuq">
                  <span className={`block font-display text-lg leading-tight transition-colors duration-200 sm:text-xl ${isActive ? 'text-gold-ivory' : 'text-neutral-200 group-hover:text-gold-soft'}`} data-id="element-344" data-mp="16ue83wu7dxmf">
                    {category.label}
                  </span>
                  <span className="mt-1 block text-[11px] uppercase tracking-[0.2em] text-neutral-400" data-id="element-345" data-mp="sud2k42zu20m">
                    {category.rows.length} {t.services.countLabel}
                  </span>
                </span>

                {isActive && <motion.span layoutId="service-card-underline" aria-hidden="true" transition={{
              duration: 0.28,
              ease
            }} className="pointer-events-none absolute inset-x-0 bottom-0 h-[3px] bg-gold-bright" data-id="element-346" data-mp="2n95xe0w1yori" />}
              </button>;
        })}
        </div>

        <AnimatePresence mode="wait" data-id="element-347" data-mp="34i8ak8yglya9">
          <motion.div key={active.id} id="panel-servicios" role="tabpanel" aria-labelledby={`tab-${active.id}`} initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -8
        }} transition={{
          duration: 0.24,
          ease
        }} className="mt-12" data-id="element-348" data-mp="34j9smxdw7l1h">
            <div className="flex items-baseline justify-between gap-6 border-b border-gold-deep/30 pb-4" data-id="element-349" data-mp="2lp4bu96dwv8s">
              <h3 className="font-display text-2xl text-gold-bright sm:text-3xl" data-id="element-350" data-mp="2ptlshzhg6sfc">
                {active.title}
              </h3>
              <span className="hidden text-[11px] uppercase tracking-[0.24em] text-neutral-500 sm:block" data-id="element-351" data-mp="521r63ptr6gg">
                {active.columnLabel}
              </span>
            </div>

            <ul className="grid grid-cols-1 gap-x-14 lg:grid-cols-2" data-id="element-352" data-mp="3mz6fky99p8b">
              {active.rows.map((row, index) => <motion.li key={row.name} initial={{
              opacity: 0,
              y: 8
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.24,
              ease,
              delay: Math.min(index * 0.035, 0.28)
            }} className="border-b border-gold-deep/15 py-5" data-id="element-353" data-mp="3utk0ldjlxd9k" data-mpi={index}>
                  <span className="block font-medium tracking-wide text-neutral-100" data-id="element-354" data-mp="hjw528km8azr">{row.name}</span>
                  <span className="mt-1 block text-[15px] leading-relaxed text-neutral-400" data-id="element-355" data-mp="w88u0llactkr">
                    {row.description}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>
        </AnimatePresence>

        <div className="mt-16 flex flex-col items-start gap-5 rounded-2xl border border-gold-soft/30 bg-[radial-gradient(ellipse_at_left,rgba(212,168,87,0.14),transparent_70%)] px-7 py-8 sm:flex-row sm:items-center sm:gap-7" data-id="element-356" data-mp="118n386ymi9kd">
          <SparkleIcon className="h-8 w-8 shrink-0 text-gold-bright" data-id="element-357" data-mp="1owa6cpzeis8t" />
          <p className="leading-relaxed text-neutral-300" data-id="element-358" data-mp="1aw93j4zktaqp">
            {t.services.callout.lead}
            <span className="text-gold-ivory" data-id="element-359" data-mp="1fvbx9ta3vujd">{t.services.callout.accent}</span>
            {t.services.callout.rest}
          </p>
        </div>
      </div>
    </section>;
}